<template>
    <div class="pb-4 text-grey block" v-show="hasItems" v-click-outside="close">
        <div v-show="!edit" class="">
            <a class="flex cursor-pointer p-2 border border-grey-lightest rounded hover:bg-white hover:border-blue-dark" @click.prevent="editIt()">
                <div class="w-full">{{ headline }}</div>
                <span class="cursor-pointer">
                    <i class="pl-8 fa fa-pencil"></i>
                </span>
            </a>
        </div>

        <div class="flex" v-if="edit" >
                <input class="focus:outline-none p-2 rounded bg-grey-lighter w-full focus:bg-white border focus:border-blue-dark"
                       type="text"
                       v-model="text"
                       v-show="edit"
                       v-on:keyup.enter="save"
                       ref="edit"
                >
                <a @click="save" v-show="edit" class="p-2 cursor-pointer"><i class="fa fa-save"></i></a>
                <a @click="close" class="p-2 cursor-pointer"><i class="fa fa-times"></i></a>
        </div>

    </div>
</template>

<script>

    import OnClickOutside from "../../components/OnClickOutside";

    export default {

        components: {OnClickOutside},

        data: () => ({
            edit: false,
            text: '',
        }),

        computed: {
            headline() {
                return this.$store.state.rawData.headline;
            },
            hasItems() {
                return this.$store.getters.history.length > 0;
            }
        },

        methods: {
            editIt() {
                this.text = this.headline;
                this.edit = true;
                this.$root.$nextTick(() => this.$refs.edit.focus());
            },
            save() {
                this.edit = false;
                this.$store.dispatch('setHeadline', {headline: this.text});
            },
            close() {
                this.edit = false;
            }
        }
    }
</script>
